import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import { JSONSupport as e } from "../../core/JSONSupport.js";
import { clone as o } from "../../core/lang.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import { ensureType as i } from "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as n } from "../../core/accessorSupport/decorators/writer.js";
import { DataLayerSource as p } from "../../layers/support/source/DataLayerSource.js";
import a from "../../geometry/SpatialReference.js";

var _u;

var d = _u = /*#__PURE__*/function (_e) {
  _inherits(u, _e);

  var _super = _createSuper(u);

  function u(t) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, t), _this.dynamicDataSource = void 0, _this.gdbVersion = null, _this.geometryPrecision = void 0, _this.historicMoment = null, _this.maxAllowableOffset = void 0, _this.objectIds = null, _this.orderByFields = null, _this.outFields = null, _this.outSpatialReference = null, _this.relationshipId = void 0, _this.start = void 0, _this.num = void 0, _this.returnGeometry = !1, _this.returnM = void 0, _this.returnZ = void 0, _this.where = null;
    return _this;
  }

  _createClass(u, [{
    key: "_writeHistoricMoment",
    value: function _writeHistoricMoment(t, e) {
      e.historicMoment = t && t.getTime();
    }
  }, {
    key: "writeStart",
    value: function writeStart(t, e) {
      e.resultOffset = this.start, e.resultRecordCount = this.num || 10, this.start > 0 && null == this.where && (e.definitionExpression = "1=1");
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _u(o({
        dynamicDataSource: this.dynamicDataSource,
        gdbVersion: this.gdbVersion,
        geometryPrecision: this.geometryPrecision,
        historicMoment: this.historicMoment && new Date(this.historicMoment.getTime()),
        maxAllowableOffset: this.maxAllowableOffset,
        objectIds: this.objectIds,
        orderByFields: this.orderByFields,
        outFields: this.outFields,
        outSpatialReference: this.outSpatialReference,
        relationshipId: this.relationshipId,
        start: this.start,
        num: this.num,
        returnGeometry: this.returnGeometry,
        where: this.where,
        returnZ: this.returnZ,
        returnM: this.returnM
      }));
    }
  }]);

  return u;
}(e);

t([r({
  type: p,
  json: {
    write: !0
  }
})], d.prototype, "dynamicDataSource", void 0), t([r({
  type: String,
  json: {
    write: !0
  }
})], d.prototype, "gdbVersion", void 0), t([r({
  type: Number,
  json: {
    write: !0
  }
})], d.prototype, "geometryPrecision", void 0), t([r({
  type: Date
})], d.prototype, "historicMoment", void 0), t([n("historicMoment")], d.prototype, "_writeHistoricMoment", null), t([r({
  type: Number,
  json: {
    write: !0
  }
})], d.prototype, "maxAllowableOffset", void 0), t([r({
  type: [Number],
  json: {
    write: !0
  }
})], d.prototype, "objectIds", void 0), t([r({
  type: [String],
  json: {
    write: !0
  }
})], d.prototype, "orderByFields", void 0), t([r({
  type: [String],
  json: {
    write: !0
  }
})], d.prototype, "outFields", void 0), t([r({
  type: a,
  json: {
    read: {
      source: "outSR"
    },
    write: {
      target: "outSR"
    }
  }
})], d.prototype, "outSpatialReference", void 0), t([r({
  json: {
    write: !0
  }
})], d.prototype, "relationshipId", void 0), t([r({
  type: Number,
  json: {
    read: {
      source: "resultOffset"
    }
  }
})], d.prototype, "start", void 0), t([n("start"), n("num")], d.prototype, "writeStart", null), t([r({
  type: Number,
  json: {
    read: {
      source: "resultRecordCount"
    }
  }
})], d.prototype, "num", void 0), t([r({
  json: {
    write: !0
  }
})], d.prototype, "returnGeometry", void 0), t([r({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(t) {
        return {
          enabled: t
        };
      }
    }
  }
})], d.prototype, "returnM", void 0), t([r({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(t) {
        return {
          enabled: t
        };
      }
    }
  }
})], d.prototype, "returnZ", void 0), t([r({
  type: String,
  json: {
    read: {
      source: "definitionExpression"
    },
    write: {
      target: "definitionExpression"
    }
  }
})], d.prototype, "where", void 0), d = _u = t([s("esri.rest.support.RelationshipQuery")], d), d.from = i(d);
var l = d;
export { l as default };